import { Component, OnInit, Input } from '@angular/core';
import { Listing } from '../../../../classes/listing';

@Component({
  selector: 'app-listing-flags',
  templateUrl: './listing-flags.component.html',
  styleUrls: ['./listing-flags.component.scss']
})
export class ListingFlagsComponent implements OnInit {

  // Whether we want to show the new or updated flag if required
  newOrUpdatedFlagType: string = null;
  isLuxury: boolean = false;
  showOpenHouse: boolean = false;

  @Input() set listing(listing: Listing) {
    // Only Supported on Residential & Luxury
    if (listing.isCommercial) {
      return;
    }

    /* For New/Updated Flags
      New Flags: listings posted in the last 7 days, shouldn't show once 7 days past listing date
      Updated Flags: Listings updated in the last 7 days, shouldn't show once 7 days past lastUpdated date
      New & Updated: listingDate takes priority, and stop showing once 7 days past the listing Date
    */

    const listingDate: Date = listing.listingDate ? new Date(listing.listingDate) : null;
    const lastUpdated: Date = listing.lastUpdated ? new Date(listing.lastUpdated) : null;
    const today = new Date();
    if (listingDate && this.numDaysBetween(today, listingDate) <= 7) {
      this.newOrUpdatedFlagType = 'new';
    }
    else if (lastUpdated && this.numDaysBetween(today, lastUpdated) <= 7) {
      this.newOrUpdatedFlagType = 'updated';
    }
    this.isLuxury = listing.isLuxury;
    this.showOpenHouse = listing.hasOpenHouse && !listing.isCommercial;

  }
  constructor() { }
  ngOnInit() {}


  /**
   * Returns the number of days between two date objects
   * @param d1
   * @param d2
   */
  private numDaysBetween(d1: Date, d2: Date) {
    const diff = Math.abs(d1.getTime() - d2.getTime());
    return diff / (1000 * 60 * 60 * 24);
  };
}
